import { render } from "./SelectJourneySetCategory.vue?vue&type=template&id=678210fa&scoped=true"
import script from "./SelectJourneySetCategory.vue?vue&type=script&lang=ts"
export * from "./SelectJourneySetCategory.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-678210fa"

export default script